import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { getTransmissionStateById } from '../../helpers/get-transmission-states.helper';
import { TransmissionState } from '../../models/transmission-status-information.model';

@Component({
  selector: 'app-button-toggle-vehicle',
  templateUrl: './button-toggle-vehicle.component.html',
  styleUrls: ['./button-toggle-vehicle.component.scss'],
})
export class ButtonToggleVehicleComponent implements OnInit, OnChanges {
  @Input() quantityVehicle = 0;
  @Input() transmissionStatusId = 0;
  @Input() isActive = false;
  @Output() onClick = new EventEmitter<number>();
  public transmissionStatus: TransmissionState | undefined;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['quantityVehicle']) {
      this.quantityVehicle = changes['quantityVehicle'].currentValue;
    }
  }

  ngOnInit(): void {
    this.transmissionStatus = getTransmissionStateById(
      this.transmissionStatusId
    );
  }
  onClickButton() {
    this.isActive = !this.isActive;
    this.onClick.emit(this.transmissionStatusId);
  }
}
